export default "__VITE_ASSET__QDPCK5W5__";